<template>
  <div
    v-edit:block="contentId"
    class="usp-block"
  >
    <ica-large-media-card
      v-bind="{
        buttonLabel,
        'content': $options.filters.stringify(content),
        editPrefix,
        imageDisplayMode,
        mediaPlacement,
        name,
        prefix,
        title,
        url,
        videoUrl,
        labelText,
        isPrimaryButton
      }"
      @button-click="trackClick"
    >
      <epi-picture
        v-if="!videoUrl && image"
        slot="media"
        v-edit="'Image'"
        :use-picture="true"
        :auto-aspect-ratio="aspectRatioMode"
        :image="image"
        :sizes="dimensions"
        :sharpen="80"
        :class="{'object-fill': imageDisplayMode === 'ImageFill' && !isIE11}"
        auto-quality="best"
        :dynamic-dimensions="imageDisplayMode === 'ImageFill'"
      />
    </ica-large-media-card>
  </div>
</template>

<script>
import IcaLargeMediaCard from '~/@ica/ica-molecules-vue/dist/LargeMediaCard'
import dataLayer from '@/analytics/dataLayer'

export default {
  name: "UspBlock",
  components: {
    IcaLargeMediaCard,
  },
  props: {
    prefix: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: [Array, String],
      default: () => []
    },
    buttonLabel: {
      type: String,
      default: ''
    },
    labelText: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ''
    },
    image: {
      type: Object,
      default: null
    },
    videoUrl: {
      type: String,
      default: null
    },
    imageDisplayMode: {
      type: String,
      default: 'ImageFill'
    },
    isPrimaryButton: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    contentId: {
      type: String,
      default: ''
    },
    mediaPlacement: {
      type: String,
      default: 'Left'
    },
    renderingSettings: {
      type: Object,
      default () {
        return {}
      }
    },
    first: {
      type: Boolean,
      default: false
    },
    last: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dimensions: {
        small: {
          width: 767
        },
        medium: {
          width: 480
        },
        large: {
          width: 570
        }
      },
      isIE11: false
    }
  },
  computed: {
    aspectRatioMode () {
      return this.$root.currentSizeLte('sm')
    }
  },
  mounted () {
    this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode
  },
  methods: {
    trackClick () {
      if (this.url && this.buttonLabel) {
        dataLayer.add({
          event: 'uspBlockSelect',
          linkName: this.buttonLabel,
          linkUrl: !/^https?:\/\//i.test(this.url) ? window.location.origin + this.url : this.url
        })
      }
    }
  },
}
</script>

<style lang="scss">

.usp-block {
  margin: 1rem 0;

  .wysiwyg--large-media-card {
    p {
      font-size: 1.25rem;
      font-weight: 300;
      line-height: 1.75rem;
      margin: 1rem 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .large-media-card__button {
    padding: 0.75rem 1.5rem;
  }

  .epi-picture {
    border-radius: 4px;
    display: flex;
    height: 100%;
    width: 100%;
    position: relative;

    picture {
      margin: auto;
    }
  }

  .empty-image-placeholder {
    padding-bottom: 33.7674%;
    border-radius: 4px;

    @include media-breakpoint-up(md) {
      padding-bottom: 0;
    }
  }

  .object-fill {
    picture,
    img {
      height: 100%;
      width: 100%;
    }

    @include media-breakpoint-up(md) {
      picture {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }

    img {
      object-fit: cover;
    }
  }

  @include media-breakpoint-up(xl) {
    .large-media-card {
      border-radius: 0.25rem;
    }
  }

  .large-media-card {
    @include fullbleed;
  }
}
</style>
